import React, { FunctionComponent } from 'react';
import { Block } from '@views/components/block';
import { Table } from '@views/components/cart';
import { Product as CartProduct } from '@views/components/cart';
import styled from 'styled-components';

import { TABLE_HEADER } from './intl';
import Skeleton from '@views/components/common/Skeleton';
const SkeletonWrapper = styled.div`
  width: 100%;
  & > span {
    width: 100%;
  }
`;

const DefaultSkeleton = ({ count = 1 }) => (
  <SkeletonWrapper>
    <Skeleton
      width="100%"
      widthRandomness={0}
      height="15px"
      heightRandomness={0}
      count={count}
    />
  </SkeletonWrapper>
);

export const Placeholder: FunctionComponent<any> = () => (
  <Block className="mb-4">
    <Block.Header className="mb-4">
      <Block.Title heading as="h3">
        Giỏ hàng
      </Block.Title>
    </Block.Header>

    <Block isSection>
      <Table>
        <Table.Body>
          {Array.from({ length: 3 }).map((item, index) => (
            <Table.Row key={index}>
              <Table.Col product data-title={TABLE_HEADER.PRODUCT}>
                <CartProduct>
                  <a className="cart-product__image pt-0">
                    <Skeleton
                      width="100%"
                      widthRandomness={0}
                      height="80px"
                      heightRandomness={0}
                    />
                  </a>
                  <CartProduct.Info>
                    <CartProduct.Name>
                      <Skeleton
                        width="180px"
                        widthRandomness={0}
                        height="15px"
                        heightRandomness={0}
                        count={3}
                      />
                    </CartProduct.Name>
                  </CartProduct.Info>
                </CartProduct>
              </Table.Col>
              <Table.Col price data-title={TABLE_HEADER.PRICE}>
                <DefaultSkeleton />
              </Table.Col>
              <Table.Col quantity data-title={TABLE_HEADER.QUANTITY}>
                <DefaultSkeleton />
              </Table.Col>
              <Table.Col total data-title={TABLE_HEADER.TOTAL}>
                <DefaultSkeleton />
              </Table.Col>
              <Table.Col action data-title={TABLE_HEADER.ACTION}>
                <DefaultSkeleton />
              </Table.Col>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    </Block>
  </Block>
);

export default Placeholder;
